<template>
  <div class="mine">
    <basiCcontainer>
      <template #head>
        <div class="mine-top-box">
          <el-tabs v-model="activeName" class="tabs-flow">
            <el-tab-pane label="项目任务" name="PersonalTask"></el-tab-pane>
            <el-tab-pane label="个人待办" name="PersonalHandle"></el-tab-pane>
          </el-tabs>
          <FilterBox :onlyReal="onlyReal" v-if="activeName === 'PersonalTask'"></FilterBox>
        </div>
      </template>
      <component :is="activeName" :uid="uid" :onlyReal="onlyReal"></component>
    </basiCcontainer>
  </div>
</template>
<script>
import PersonalTask from './personalTask'
import PersonalHandle from './personalHandle'
import FilterBox from './filterBox'
import { mapMutations } from 'vuex'
export default {
  props: ['uid', 'onlyReal'],
  components: {
    PersonalTask,
    PersonalHandle,
    FilterBox
  },
  beforeRouteLeave (to, from, next) {
    this.clear_queryMsg()
    next()
  },
  data() {
    return {
      activeName: 'PersonalTask'
    }
  },
  methods: {
    ...mapMutations('mine/mine', ['clear_queryMsg'])
  }
}
</script>
<style lang="scss">
.personal-time {
  width: 321px !important;
  .el-month-table {
    margin-bottom: 98px;
  }
  .el-year-table {
    margin-bottom: 26px;
  }
  .el-date-table td span {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    line-height: 32px;
  }
  .el-date-table td.available {
    &:hover {
      color: initial;
    }
  }
  .el-date-table td span {
    &:hover {
      background-color: #f7f8f9;
    }
    &:active {
      background-color: #eaebec;
    }
  }
  .el-picker-panel__sidebar .el-picker-panel__shortcut:last-child {
    color: #ff3939;
  }
  .el-picker-panel__sidebar .el-picker-panel__shortcut {
    text-align: center;
  }
  .el-picker-panel__sidebar {
    top: 343px;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 64px;
    align-items: center;
    padding: 0;
    border: 0 none;
    border-top: 1px solid rgba(230, 231, 233, 0.6);
  }
  .el-picker-panel__body {
    margin-left: 0;
    margin-bottom: 64px;
  }
  .today {
    position: relative;
    &::after {
      content: "";
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      position: absolute;
      bottom: 2px;
      left: 50%;
      transform: translate(-50%, 0);
      background-color: $color-active;
      flex-shrink: 0;
    }
  }
  .today.current {
    &::after {
      background-color: #fff;
    }
  }

  .el-year-table,
  .el-month-table {
    td.today .cell {
      color: $color-active;
    }
    .today {
      &::after {
        bottom: 26px;
      }
    }
    .cell {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      line-height: 48px;
      font-weight: normal;
      color: initial;
      &:hover {
        background-color: #f7f8f9;
        color: initial;
      }
      &:active {
        background-color: #eaebec;
        color: initial;
      }
    }
  }
  .el-year-table td.current:not(.disabled) .cell {
    background: linear-gradient(225deg, #269af9 0%, #0f73e9 100%);
    color: #fff;
  }
  .el-month-table {
    .today {
      &::after {
        bottom: 10px;
      }
    }
  }
  .el-month-table td.current:not(.disabled) .cell {
    background: linear-gradient(225deg, #269af9 0%, #0f73e9 100%);
    color: #fff;
  }
}
.mine {
  height: 100%;
  .search-box {
    border: 0 none;
    .el-tabs__item {
      font-size: 14px;
    }
  }
  .mine-top-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }
}
</style>
